import React from 'react';

import {translate} from 'iss/strings';
import {runBatchOps} from 'iss/utils/batchOps';
import {changeFormGradingScale} from 'iss/service/FormService';
import {CollapsibleButtonPanel} from 'iss/widgets/Panels';
import {FormList} from 'iss/widgets/FormList';
import {GradeSelector} from 'iss/widgets/Selectors';
import {ModalForm} from 'iss/widgets/batchOps/ModalForm';
import {listFailuresWithMessage} from 'iss/widgets/batchOps/evaluationForm/BatchOpFailure';

export function getChangeFormGradingScalesForScale(scale) {
  return {
    id: "changeGradingScale",
    title: "evaluationFormOperations.changeGradingScale.title",
    progressMessage: "evaluationFormOperations.changeGradingScale.progressMessage",
    components: {
      settings: ({operationTargets, onCancel, startOperation}) => {
        return <ModalForm proceedText={translate('evaluationFormOperations.changeGradingScale.proceed')}
          onSubmit={(formData) => {
            startOperation(changeGradingScales(operationTargets, scale, formData));
          }}
          onCancel={onCancel}>
          <GradeSelector id="grades" scale={scale} valuePath="gradeId" label="evaluationFormOperations.changeGradingScale.chooseAimedGrade" clearable={true} />
          <p>
            {translate('evaluationFormOperations.changeGradingScale.confirmMessage', {count: operationTargets.length})}
          </p>
          <CollapsibleButtonPanel buttonText={translate('evaluationFormOperations.changeGradingScale.forms')}>
            <FormList compact={true} forms={operationTargets}/>
          </CollapsibleButtonPanel>
        </ModalForm>;
      },
      success: <p>{translate("evaluationFormOperations.changeGradingScale.success")}</p>,
      failure: listFailuresWithMessage("evaluationFormOperations.changeGradingScale.failure")
    },
  };
}

function changeGradingScales(targets, scale, {gradeId}) {
  const ops = targets.map((target) => (
    {
      operation: changeFormGradingScale(target.id,
        {
          gradingScaleId: scale.id,
          aimedGradeId: gradeId
        }),
      form: target
    }));
  return runBatchOps(ops);
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/evaluationForm/changeFormGradingScales.jsx